const TRAILING_SLASH = /\/$/;
const TAB_SEARCH_STORAGE_PREFIX = 'fingo-tab-search:';

const stripTrailingSlash = (path) => path.replace(TRAILING_SLASH, '');

export const getPreserveSearchPathsKey = (tabs) => (
  tabs
    .filter((tab) => tab.preserveSearch)
    .map((tab) => tab.path)
    .join(',')
);

export const getPreserveSearchPaths = (preserveSearchPathsKey) => (
  preserveSearchPathsKey ? preserveSearchPathsKey.split(',') : []
);

export const getTabRouteLocation = (location, routePath, defaultTabPath) => (
  stripTrailingSlash(location.pathname) === stripTrailingSlash(routePath)
    ? { ...location, pathname: `${routePath}/${defaultTabPath}` }
    : location
);

export const getTabSearchStorageKey = (parentRoutePath, tabPath) => (
  `${TAB_SEARCH_STORAGE_PREFIX}${stripTrailingSlash(parentRoutePath)}/${tabPath}`
);

export const isDetailRoute = (pathname, parentRoutePath, tabPath) => {
  if (!tabPath) return false;
  const tabBase = `${stripTrailingSlash(parentRoutePath)}/${tabPath}`;
  return stripTrailingSlash(pathname).startsWith(`${tabBase}/`);
};

export const getActiveTabPath = (pathname, parentRoutePath, defaultTabPath) => {
  const parent = stripTrailingSlash(parentRoutePath);
  const current = stripTrailingSlash(pathname);

  if (current === parent) {
    return defaultTabPath;
  }

  if (!current.startsWith(`${parent}/`)) {
    return defaultTabPath;
  }

  return current.slice(parent.length + 1).split('/')[0];
};

export const persistTabSearch = (parentRoutePath, tabPath, search) => {
  const key = getTabSearchStorageKey(parentRoutePath, tabPath);
  if (!search) {
    sessionStorage.removeItem(key);
    return;
  }
  sessionStorage.setItem(key, search);
};

export const readTabSearch = (parentRoutePath, tabPath) => {
  const key = getTabSearchStorageKey(parentRoutePath, tabPath);
  return sessionStorage.getItem(key) || '';
};
